import styled from 'styled-components'
import React from 'react';
import { ReactComponent as ShareIcon } from '../../../../assets/images/share.svg'

const CopyProfileUrlLabel = styled.label`
text-align: right;
margin-bottom: 0.5rem;
font-weight: bold;
display:flex;
align-items:center;
justify-content: flex-end;
--iconColor: ${({ theme }) => theme.text1};
span {
  font-size: 0.8rem;
  opacity: 0.8;
  :hover {
      transform: scale(1.02);
  }
}
svg {
    margin-left: 5px;
    height: 16px;
    width: 16px;
}

`

interface NFTShareProfileProps {
    accountAddress: string,
    label: string,
    onURLCopied?: (url: string) => void;
}

const NFTShareProfile = (props: NFTShareProfileProps) => {
    const url = `${window.location.origin}/#/profile/${props.accountAddress}`;
    const onClickShareProfileUrl = () => {
        navigator.clipboard.writeText(url);
        if (props.onURLCopied) props.onURLCopied(url);
    }
    return (
        <CopyProfileUrlLabel title={url} onClick={onClickShareProfileUrl}><span>{props.label}</span><ShareIcon /></CopyProfileUrlLabel>
    )
}
export default NFTShareProfile;